export default "__VITE_ASSET__3da69df7__"